import React, { useState } from "react";
import Creatives from "../creatives/Creatives";
import DownloadFormat from "../downloadFormat/DownloadFormat";
import Previews from "../previews/Previews";
import InputFieldFormArray from "../inputFieldFormArray/InputFieldFormArray";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import SpecsheetButtonBlue from "../../button/specsheetButtonBlue/SpecsheetButtonBlue";
import Keywords from "../keywords/Keywords";
import SpecsheetButtonWhite from "../../button/specsheetButtonWhite/SpecsheetButtonWhite";
import "./Form.css";
import ListSubheader from "../listSubheader/ListSubheader";
import Countries from "../countries/Countries";

const Form = ({
  control,
  register,
  errors,
  showSidebarDownloads,
  showSidebarExtraSearchOptions,
  showSidebarPreviews,
  sidebarExtraSearchOptions,
  sidebarPreviews,
  sidebarDownloads,
  setOverlayActive,
  errorMessage,
  setManageCreatives,
  manageCreatives,
  positionButton,
  setPositionButton,
}) => {
  // This will show the download section.
  function showDownload() {
    return (
      <div className="download-links-container">
        <div className="download-section">
          <div className="container-title-download">
            <p className="download-template-title">DOWNLOAD TEMPLATE</p>
            <FontAwesomeIcon
              className="download-icon"
              icon={faXmark}
              onClick={showSidebarDownloads}
            />
          </div>
          <div className="download-introduction-container">
            <p>Download this template to your device and start creating</p>
          </div>

          <DownloadFormat
            {...{ control, register, errors, showSidebarDownloads }}
          />
        </div>
      </div>
    );
  }

  // Always display todays date in the form as a placeholder.
  function dateToday() {
    var dateObj = new Date();
    var month = dateObj.getUTCMonth() + 1; //months from 1-12
    var day = dateObj.getUTCDate();
    var year = dateObj.getUTCFullYear();

    const newdate = day + "-" + month + "-" + year;
    return newdate;
  }

  return (
    <div>
      <div className="sheet-container-top">
        <div className="top-container">
          <div className="extra-container">
            <div className="top-inner-container">
              <div className="inner-divider-block">
                <div className="vertical-divider"></div>
                <p className="horizontal-divider"></p>
                <div className="title-specsheet-form divider">
                  <InputFieldFormArray
                    label="Specsheet name* "
                    fieldRef={register("templateName", {
                      required: true,
                    })}
                    name="templateName"
                    type="text"
                  />
                  <p className="message">
                    Please fill in the name of the specsheet following the
                    following structure:
                  </p>
                  <p className="message">
                    [type] - [location (if type is publisher)] - [device] -
                    [platform] - [template_name]
                  </p>
                </div>

                <p className="horizontal-divider"></p>
                <div className="specification-sheet-wrapper">
                  <p className="specification-sheet divider">
                    SPECIFICATION SHEET
                  </p>
                  <div className="extra-search-options">
                    <SpecsheetButtonBlue
                      type="button"
                      handleClick={showSidebarExtraSearchOptions}
                    >
                      EXTRA SEARCH OPTIONS
                    </SpecsheetButtonBlue>
                  </div>
                </div>
                <p className="horizontal-divider"></p>
                <div className="divider">
                  <span className="divider">
                    <div className="active-wrapper">
                      <section className="select-wrapper">
                        <div className="label-wrapper">
                          <label>Activate template </label>
                        </div>
                        <div>
                          <select
                            {...register(`active`, {
                              required: false,
                            })}
                          >
                            <option value="active">Active</option>
                            <option value="notActive">Not active</option>
                          </select>
                        </div>
                      </section>
                    </div>
                  </span>
                </div>

                <p className="horizontal-divider"></p>
                <div className="divider">
                  <span className="divider">
                    <InputFieldFormArray
                      label="Last Update"
                      fieldRef={register("lastUpdate", {
                        required: false,
                        pattern: {
                          value:
                            /^(?:(?:31(-)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(-)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(-)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/,
                        },
                      })}
                      name="lastUpdate"
                      placeholder={dateToday()}
                      type="text"
                    />
                  </span>
                </div>

                <p className="horizontal-divider"></p>
                <p className="divider">
                  <span>Get support</span>

                  <span
                    className="divider mail"
                    onClick={() =>
                      (window.location = "mailto:support@weborama.nl")
                    }
                  >
                    support@weborama.nl
                  </span>
                </p>
                <p className="horizontal-divider"></p>
              </div>
            </div>

            <div
              className={
                sidebarExtraSearchOptions
                  ? "extra-search-options-slider__active"
                  : "extra-search-options-slider"
              }
            >
              <div className="extra-serach-options-container">
                <div className="container-title-slider">
                  <p className="extra-search-options-title">
                    EXTRA SEARCH OPTIONS
                  </p>
                  <FontAwesomeIcon
                    className="download-icon"
                    icon={faXmark}
                    onClick={showSidebarExtraSearchOptions}
                  />
                </div>

                <Countries {...{ control, register, errors }} />

                <ListSubheader {...{ control, register, errors }} />

                <div className="keywords-wrapper">
                  <Keywords
                    {...{
                      control,
                      register,
                      errors,
                      showSidebarExtraSearchOptions,
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="preview-download-container">
              <SpecsheetButtonBlue
                type="button"
                handleClick={showSidebarDownloads}
              >
                DOWNLOAD TEMPLATE
              </SpecsheetButtonBlue>

              <SpecsheetButtonWhite
                type="button"
                handleClick={showSidebarPreviews}
              >
                PREVIEW TEMPLATE
              </SpecsheetButtonWhite>
            </div>
          </div>
        </div>
        <div className="preview-download-container-mobile">
          <div className="top-container">
            <div className="extra-container">
              <div className="top-inner-container">
                <div className="inner-divider-block">
                  <div className="preview-download-inner-container-mobile">
                    <p className="horizontal-divider"></p>

                    <div className="first-button-mobile">
                      <SpecsheetButtonBlue
                        type="button"
                        handleClick={showSidebarDownloads}
                      >
                        DOWNLOAD TEMPLATE
                      </SpecsheetButtonBlue>
                    </div>

                    <p className="horizontal-divider"></p>
                    <p className="horizontal-divider"></p>

                    <div className="second-button-mobile">
                      <SpecsheetButtonWhite
                        type="button"
                        handleClick={showSidebarPreviews}
                      >
                        PREVIEW TEMPLATE
                      </SpecsheetButtonWhite>
                    </div>
                    <p className="horizontal-divider"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={
          sidebarPreviews ? "preview-slider__active" : "preview-slider"
        }
      >
        <div className="preview-links-container">
          <div className="container-title-download">
            <p className="preview-template-title">PREVIEW TEMPLATE</p>
            <FontAwesomeIcon
              className="download-icon"
              icon={faXmark}
              onClick={showSidebarPreviews}
            />
          </div>

          <div className="preview-container">
            <div className="preview-introduction-container">
              <p>
                Scan QR code or click on the link below to preview the template
              </p>
            </div>

            <p className="template-name"></p>
            <div className="template-tiles-container">
              <Previews {...{ control, register, errors }} />
            </div>
          </div>
          <section className="done-section">
            <SpecsheetButtonWhite
              type="button"
              handleClick={showSidebarPreviews}
            >
              Done
            </SpecsheetButtonWhite>
          </section>
        </div>
      </div>
      <div
        className={
          sidebarDownloads ? "download-slider__active" : "download-slider"
        }
      >
        {showDownload()}
      </div>

      <div className="outer-specification-container-form">
        <div className="specification-container">
          <p className="specification-title">SPECIFICATIONS</p>

          <div className="additional-template-info-form">
            <InputFieldFormArray
              label="Additional template info"
              fieldRef={register("additionalTemplateInformation", {
                required: false,
              })}
              name="additionalTemplateInformation"
              type="text"
            />
            <p className="message">
              Only use if specific extra information is needed. Please check
              with sales if needed.
            </p>
          </div>

          <div className="icon-container">
            <div className="icon-container-horizontal"></div>
          </div>
        </div>
        <div className="creative-container-outer-wrapper">
          <div className="creative-container-form">
            <Creatives
              {...{
                control,
                register,
                errors,
                setOverlayActive,
                setManageCreatives,
                manageCreatives,
                positionButton,
                setPositionButton,
              }}
            />
          </div>
        </div>
      </div>
      {errorMessage && (
        <p className="error">Something went wrong, please try again later.</p>
      )}
    </div>
  );
};

export default Form;
